/**
 * Home queries
 */

import gql from 'graphql-tag'
// TODO: Check if all the data requested in the featuredProducts field
// is required
export const getHomepageInfo = gql`
  query getHomepageContent($sportRoute: String, $isMobile: Boolean) {
    getHomepageContent(sportRoute: $sportRoute, isMobile: $isMobile) {
      carouselSettings {
        slideTransition: slide_transition
        slideDuration: slide_duration
        secondarySlideTransition: secondary_slide_transition
        secondarySlideDuration: secondary_slide_duration
        positions
        version2Home: version2
        hasCarousel: has_carousel
      }
      sportId: sport_id
      title
      navbar
      showFooter
      hideYotpo
      hideCalendar
      navigationType
      version2
      positions
      hasCarousel
      homepageImages {
        id
        desktopImage: image
        mobileImage: image_mobile
        url: link
        assetType: type
        richText: rich_text
        cssStyle: css_style
        altDescription: alt_description
        verticalAlign: vertical_align
        backgroundImage: background_image
        backgroundColor: background_color
        desktop
        mobile
      }
      featuredBanners {
        id
        url
        urlMobile: url_mobile
        sportId: sport_id
        isVideo: is_video
      }
      secondaryFeaturedImages {
        id
        desktopImage: image
        mobileImage: image_mobile
        assetType: type
        url: link
        width
        richText: rich_text
        cssStyle: css_style
        altDescription: alt_description
        verticalAlign: vertical_align
        backgroundImage: background_image
        backgroundColor: background_color
        volume
        productInfo: product_info
        desktop
        mobile
      }
      productTiles {
        id
        contentTile: content_tile
        title
        image
      }
    }
  }
`

export const getDesignLabInfo = gql`
  query getDesignLabInfo {
    deliveryDays: getDesignLabInfo {
      days: delivery_days
      daysCA: delivery_days_ca
      calendarLabel: calendar_label
    }
    deliveryDate: getDesignLabInfo(onlyData: false) {
      date: delivery_days
      calendarLabel: calendar_label
    }
  }
`

export const profileSettingsQuery = gql`
  query profile {
    profileData: getUserProfile {
      userProfile {
        id
        country_code
      }
      reseller {
        id
        status
        comission
        inline
      }
    }
  }
`

export const getShortenURLQuery = gql`
  query getShortenURL($id: String) {
    shortenURL: getShortenURL(id: $id) {
      id
      url
    }
  }
`

export const getMainHeaderImages = gql`
  query getHomepageContent($sportRoute: String, $isMobile: Boolean) {
    getHomepageContent(sportRoute: $sportRoute, isMobile: $isMobile) {
      mainHeaderImages {
        id
        desktopImage: image
        mobileImage: image_mobile
        url: link
        assetType: type
        richText: rich_text
        cssStyle: css_style
        altDescription: alt_description
        verticalAlign: vertical_align
        backgroundImage: background_image
        backgroundColor: background_color
        desktop
        mobile
      }
    }
  }
`

export const getFeaturedImages = gql`
  query getHomepageContent($sportRoute: String, $isMobile: Boolean) {
    getHomepageContent(sportRoute: $sportRoute, isMobile: $isMobile) {
      featuredImages {
        id
        desktopImage: image
        mobileImage: image_mobile
        assetType: type
        url: link
        width
        richText: rich_text
        cssStyle: css_style
        altDescription: alt_description
        verticalAlign: vertical_align
        backgroundImage: background_image
        backgroundColor: background_color
        volume
        productInfo: product_info
        desktop
        mobile
      }
    }
  }
`

export const getFeaturedProducts = gql`
query getHomepageContent($sportRoute: String, $isMobile: Boolean) {
  getHomepageContent(sportRoute: $sportRoute, isMobile: $isMobile) {
    featuredProducts {
      id
      code
      yotpoId: yotpo_id
      name
      type: name
      description: short_description
      collections
      discontinued
      serie
      customizable: design_center
      priceRange {
        quantity
        price
        abbreviation
        shortName: short_name
      }
      images: pictures2 {
        thumbnail
        front: front_image
      }
    }
  }
}
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/Home/data.ts